import { inViewPort } from "../utils/inViewPort";
var LazyLoad = /** @class */ (function () {
    function LazyLoad(img) {
        this.image = img;
        var _a = this.image.dataset, _b = _a.src, src = _b === void 0 ? "" : _b, _c = _a.srcset, srcset = _c === void 0 ? "" : _c;
        this.src = src;
        this.srcset = srcset;
        this.loaded = false;
        this.init();
    }
    LazyLoad.prototype.init = function () {
        var _this = this;
        inViewPort(this.image, function () {
            if (_this.src) {
                _this.image.setAttribute("src", _this.src);
            }
            if (_this.srcset) {
                _this.image.setAttribute("srcset", _this.srcset);
            }
            _this.image.classList.add("loaded");
            _this.loaded = true;
        });
    };
    return LazyLoad;
}());
export { LazyLoad };
var LazyLoadInit = {
    init: function () {
        var elements = document.querySelectorAll(".lazy-image");
        Array.from(elements).map(function (element) { return new LazyLoad(element); });
    },
};
export default LazyLoadInit;
